import { ref } from 'vue'
import type { Ref } from 'vue'
import { FOOTER_SOCIAL_MENU } from '../entities/MenuType'
import type { FooterSocialLinks } from '../entities/MenuFooterSocial'
import { contentCall } from './useMenu'

export const useMenuFooterSocial = async () => {
  const data = await contentCall(FOOTER_SOCIAL_MENU, false)

  const dataAdapted: FooterSocialLinks = {
    // @ts-ignore
    title: data.title,
    links: data.links,
  }
  const MenuFooterSocialLinksInstance: Ref<FooterSocialLinks> = ref(dataAdapted)

  return { MenuFooterSocialLinksInstance }
}
